import { CustomersStoreState } from "./CustomersStore.types";


export const customersStoreState: CustomersStoreState = {
  customers: [],
  washingTypes: []
 };